<template>
  <div id="box7">
    <div class="box">
      <div
        class="item"
        v-for="(item, index) in [1, 2, 3, 4, 5, 6]"
        :key="index"
      >
        <div class="icon"></div>
        <img :src="require(`../assets/box7/${item}.png`)" alt="" />
        <div class="button" @click="Open(item)">免费领</div>
      </div>
      <div style="height: 0.453rem; width: 100%"></div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    Open(e) {
      let name = "";
      switch (e) {
        case 1:
          name = "Java";
          break;
        case 2:
          name = "Python";
          break;
        case 3:
          name = "UI";
          break;
        case 4:
          name = "大数据";
          break;
        case 5:
          name = "前端";
          break;
        case 6:
          name = "软件测试";
          break;
      }
      this.$mai(2, null, `免费领${name}学习线路图`);
      this.$store.commit("Openpop", 3);
    },
  },
};
</script>

<style lang='scss' scoped>
.box {
  display: flex;
  flex-flow: row wrap;
  margin: 0 auto;
  width: 690px;
  background-color: #6b00d9;
  .item {
    position: relative;
    margin: 30px 0 0 20px;
    width: 310px;
    height: 302px;
    background-color: #9f7fff;
    border-radius: 10px;
    .icon {
      position: absolute;
      top: -5px;
      left: -6px;
      width: 85px;
      height: 85px;
      background-image: url("../assets/icon.png");
      background-size: cover;
    }
    img {
      margin: 0 auto;
      margin-top: 10px;
      display: block;
      width: 290px;
      height: 200px;
      background-color: #ffffff;
      border-radius: 6px;
    }
    .button {
      margin: 0 auto;
      margin-top: 12px;
      width: 260px;
      height: 66px;
      background-image: url("../assets/btn.png");
      background-size: 100% 100%;  
      text-align: center;
      font-family: SourceHanSansCN-Medium;
      font-size: 28px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 66px;
      letter-spacing: 1px;
      color: #5530fd;
      border: solid 2px #532bff;
        border-radius: 12px;
    }
  }
}
</style>